const state = () => ({
    zujin: [],
    dianfei: [],
    lenshuifei: [],
    fywufei: [],
    addList: [],
    listTab2: [],
    listTab3: [],
})
const getters = {
    zujin: (state) => state.zujin,
    dianfei: (state) => state.dianfei,
    lenshuifei: (state) => state.lenshuifei,
    fywufei: (state) => state.fywufei,
    addList: (state) => state.addList,
    listTab2: (state) => state.listTab2,
    listTab3: (state) => state.listTab3,
}
const mutations = {

    setZujin(state, zujin) {
        state.zujin = zujin
    },
    setDianfei(state, dianfei) {
        state.dianfei = dianfei
    },
    setLenshuifei(state, lenshuifei) {
        state.lenshuifei = lenshuifei
    },
    setFywufei(state, fywufei) {
        state.fywufei = fywufei
    },
    setAddLlist(state, addList) {
        state.addList = addList
    },
    setListTab2(state, listTab2) {
        state.listTab2 = listTab2
    },
    setListTab3(state, listTab3) {
        state.listTab3 = listTab3
    },
}
const actions = {
    setZujin({ commit }, zujin) {
        commit('setZujin', zujin)
    },
    setDianfei({ commit }, dianfei) {
        commit('setDianfei', dianfei)
    },
    setLenshuifei({ commit }, lenshuifei) {
        commit('setLenshuifei', lenshuifei)
    },
    setFywufei({ commit }, fywufei) {
        commit('setFywufei', fywufei)
    },
    setAddLlist({ commit }, addList) {
        commit('setAddLlist', addList)
    },
    setListTab2({ commit }, listTab2) {
        commit('setListTab2', listTab2)
    },
    setListTab3({ commit }, listTab3) {
        commit('setListTab3', listTab3)
    },
}
export default {
    state,
    getters,
    mutations,
    actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/getTabDataList.js